import React, { useState, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import cn from "classnames";
import OutsideClickHandler from "react-outside-click-handler";
import styles from "./User.module.sass";
import Icon from "../../Icon";
import { useAuth } from "../../../contexts/AuthContext";
import { toast } from "react-toastify";
import ModalConditionGeneral from "../../ModalConditionGeneral";
import ModalPolitiqueConfidentialite from "../../ModalPolitiqueConfidentialite";
import ModalReglement from "../../ModalReglement";

// Menus pour les administrateurs
const adminItems = [
    {
        menu: [
            {
                title: "Mes paramètres",
                url: "/admin/settings",
            }
        ],
    },
    {
        menu: [
            {
                title: "Politique de confidentialité",
                url: "/conditions",
            },
            {
                title: "Conditions générales",
                url: "/general",
            },
            {
                title: "Règlement intérieur",
                url: "/reglement",
            }
        ],
    },
    {
        menu: [
            {
                title: "Déconnexion",
            },
        ],
    },
];

// Menus pour les étudiants
const studentItems = [
    {
        menu: [
            {
                title: "Mes paramètres",
                url: "/student/settings",
            }
        ],
    },
    {
        menu: [
            {
                title: "Politique de confidentialité",
                url: "/conditions",
            },
            {
                title: "Conditions générales",
                url: "/general",
            },
            {
                title: "Règlement intérieur",
                url: "/reglement",
            }
        ],
    },
    {
        menu: [
            {
                title: "Déconnexion",
            },
        ],
    },
];

// Menus pour les entreprises
const companyItems = [
    {
        menu: [
            {
                title: "Mes paramètres",
                url: "/company/settings",
            }
        ],
    },
    {
        menu: [
            {
                title: "Politique de confidentialité",
                url: "/conditions",
            },
            {
                title: "Conditions générales",
                url: "/general",
            },
            {
                title: "Règlement intérieur",
                url: "/reglement",
            }
        ],
    },
    {
        menu: [
            {
                title: "Déconnexion",
            },
        ],
    },
];

const User = ({ className }) => {
    const [visible, setVisible] = useState(false);
    const [visibleModalConditionGeneral, setVisibleModalConditionGeneral] = useState(false);
    const [visibleModalPolitiqueConfidentialite, setVisibleModalPolitiqueConfidentialite] = useState(false);
    const [visibleModalReglement, setVisibleModalReglement] = useState(false);
    const { pathname } = useLocation();
    const { currentUser, logout, isAdmin, isStudent, isCompany } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        setVisible(false);
        toast.success('Déconnexion réussie');
        navigate('/sign-in');
    };

    // Sélectionner les menus en fonction du rôle de l'utilisateur
    let items = [];
    if (isAdmin) {
        items = adminItems;
    } else if (isStudent) {
        items = studentItems;
    } else if (isCompany) {
        items = companyItems;
    } else {
        items = adminItems; // Par défaut
    }

    return (
        <>
            <OutsideClickHandler onOutsideClick={() => setVisible(false)}>
                <div
                    className={cn(styles.user, className, {
                        [styles.active]: visible,
                    })}
                >
                    <button
                        className={styles.head}
                        onClick={() => setVisible(!visible)}
                    >
                        <img src={"/images/content/user_logo.png"} alt="User" />
                    </button>
                    <div className={styles.body}>
                        {items.map((item, index) => (
                            <div className={styles.menu} key={index}>
                                {item.menu.map((x, index) =>
                                    x.url ? (
                                        x.title === "Politique de confidentialité" ? (
                                            <button
                                                className={cn(styles.item, {
                                                    [styles.color]: x.color,
                                                })}
                                                onClick={() => {
                                                    setVisibleModalPolitiqueConfidentialite(true);
                                                    setVisible(false);
                                                }}
                                                key={index}
                                            >
                                                {x.icon && (
                                                    <Icon name={x.icon} size="24" />
                                                )}
                                                {x.title}
                                            </button>
                                        ) : x.title === "Conditions générales" ? (
                                            <button
                                                className={cn(styles.item, {
                                                    [styles.color]: x.color,
                                                })}
                                                onClick={() => {
                                                    setVisibleModalConditionGeneral(true);
                                                    setVisible(false);
                                                }}
                                                key={index}
                                            >
                                                {x.icon && (
                                                    <Icon name={x.icon} size="24" />
                                                )}
                                                {x.title}
                                            </button>
                                        ) : x.title === "Règlement intérieur" ? (
                                            <button
                                                className={cn(styles.item, {
                                                    [styles.color]: x.color,
                                                })}
                                                onClick={() => {
                                                    setVisibleModalReglement(true);
                                                    setVisible(false);
                                                }}
                                                key={index}
                                            >
                                                {x.icon && (
                                                    <Icon name={x.icon} size="24" />
                                                )}
                                                {x.title}
                                            </button>
                                        ) : (
                                            <NavLink
                                                className={cn(styles.item, {
                                                    [styles.color]: x.color,
                                                    [styles.active]: pathname === x.url,
                                                })}
                                                to={x.url}
                                                onClick={() => setVisible(false)}
                                                key={index}
                                            >
                                                {x.icon && (
                                                    <Icon name={x.icon} size="24" />
                                                )}
                                                {x.title}
                                            </NavLink>
                                        )
                                    ) : (
                                        <button
                                            className={styles.item}
                                            onClick={x.title === "Déconnexion" ? handleLogout : () => setVisible(false)}
                                            key={index}
                                        >
                                            {x.title}
                                        </button>
                                    )
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </OutsideClickHandler>
            <ModalConditionGeneral
                visible={visibleModalConditionGeneral}
                onClose={() => setVisibleModalConditionGeneral(false)}
            />
            <ModalPolitiqueConfidentialite
                visible={visibleModalPolitiqueConfidentialite}
                onClose={() => setVisibleModalPolitiqueConfidentialite(false)}
            />
            <ModalReglement
                visible={visibleModalReglement}
                onClose={() => setVisibleModalReglement(false)}
            />
        </>
    );
};

export default User;
